<script setup lang="ts">
import { computed } from 'vue'
import * as lucideIcons from 'lucide-vue-next'
import * as heroIcons from '@heroicons/vue/24/outline'

interface TProps {
  name: string
  cssClass?: string
}

const props = defineProps<TProps>()

const IconComponent = computed(() => {
  const name = (props.name || '').trim()
  if (name.length < 1) return null

  // 1. Try Lucide
  let Icon = (lucideIcons as any)[name]

  if (!Icon) {
    // 2. Try HeroIcons
    Icon = (heroIcons as any)[name]

    if (!Icon) {
      console.warn(`Icon "${name}" not found in lucideIcons nor heroIcons`)
      return null
    }
  }

  return Icon
})
</script>

<template>
  <component :is="IconComponent" v-if="IconComponent" :class="cssClass" aria-hidden="true" />
</template>
